import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const ContractModelForm = ({ initialData, onSubmit }) => {

    const [t, i18n] = useTranslation("global", "absenceReport");


    const [formData, setFormData] = useState(
        initialData || {
            guid: "",
            name: "",
            description: "",
            baseHours: 0,
            workerClasses: [],
        }
    );

    // Sincronizza lo stato interno con initialData quando cambia
    useEffect(() => {
        setFormData(
            initialData || {
                guid: "",
                name: "",
                description: "",
                baseHours: 0,
                workerClasses: [],
            }
        );
    }, [initialData]);

    //console.log("GUID: " + formData.guid + " -> formData " + JSON.stringify(formData))

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleWorkerClassChange = (index, field, value) => {
        const updatedWorkerClasses = [...formData.workerClasses];
        updatedWorkerClasses[index] = {
            ...updatedWorkerClasses[index],
            [field]: value,
        };
        setFormData({
            ...formData,
            workerClasses: updatedWorkerClasses,
        });
    };

    const addWorkerClass = () => {
        setFormData({
            ...formData,
            workerClasses: [
                ...formData.workerClasses,
                { guid: "", name: "", holidaysHours: "", rolHours: 0, leaveHours: 0 },
            ],
        });
    };

    const removeWorkerClass = (index) => {
        const updatedWorkerClasses = formData.workerClasses.filter(
            (_, i) => i !== index
        );
        setFormData({
            ...formData,
            workerClasses: updatedWorkerClasses,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="container">
            <div className="mb-3">
                <label htmlFor="name" className="form-label">
                    {t("property.name")}
                </label>
                <input
                    type="text"
                    id="name"
                    name="name"
                    className="form-control"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                />
            </div>

            <div className="mb-3">
                <label htmlFor="description" className="form-label">
                    {t("property.description")}
                </label>
                <textarea
                    id="description"
                    name="description"
                    className="form-control"
                    value={formData.description}
                    onChange={handleInputChange}
                    required
                ></textarea>
            </div>

            <div className="mb-3 col-4">
                <label htmlFor="baseHours" className="form-label">
                    {t("absenceReport:helper.based_on")} ({t("unit.hours")})
                </label>
                <input
                    type="number"
                    min="0"
                    step="1"
                    id="baseHours"
                    name="baseHours"
                    className="form-control"
                    value={formData.baseHours}
                    onChange={handleInputChange}
                    required
                />
            </div>

            <h5>Categorie</h5>
            <div className="p-2">
                {formData.workerClasses?.map((workerClass, index) => {

                    return (


                        <div key={workerClass.guid || index} className="bg-dark  p-3 mb-3 col">
                            <div className="row">


                                <div className="mb-3 col">
                                    <label htmlFor={`workerClass-name-${index}`} className="form-label">
                                        {t("property.name")}
                                    </label>

                                    <input
                                        type="text"
                                        id={`workerClass-name-${index}`}
                                        className="form-control"
                                        value={workerClass.name}
                                        onChange={(e) =>
                                            handleWorkerClassChange(index, "name", e.target.value)
                                        }
                                        required
                                    />
                                </div>

                                <div className="col">

                                    <div className="text-end">
                                        {
                                            workerClass.active > 0 &&
                                            <span className="small "><i className="fa-solid fa-triangle-exclamation text-warning"></i> {t("absenceReport:helper.active_contracts", { count: workerClass.active })} </span>

                                        }

                                        <button
                                            type="button"
                                            className={`btn btn-danger btn-sm ${workerClass.active > 0 && "disabled"}`}
                                            onClick={() => removeWorkerClass(index)}
                                        ><i className="fa-solid fa-xmark"></i>
                                        </button>
                                    </div>

                                </div>

                            </div>

                            <div className="row">
                                <div className="mb-3 col">
                                    <label
                                        htmlFor={`workerClass-holidaysHours-${index}`}
                                        className="form-label"
                                    >
                                        {t("absenceReport:entity.leaveReport.type.holidays")} <b> {t("unit.hours")}</b>
                                    </label>
                                    <input
                                        type="text"
                                        id={`workerClass-holidaysHours-${index}`}
                                        className="form-control"
                                        value={workerClass.holidaysHours}
                                        onChange={(e) =>
                                            handleWorkerClassChange(index, "holidaysHours", e.target.value)
                                        }
                                    />
                                </div>
                                <div className="mb-3 col">
                                    <label
                                        htmlFor={`workerClass-rolHours-${index}`}
                                        className="form-label"
                                    >
                                        {t("absenceReport:entity.leaveReport.type.timeOff")} <b>{t("unit.hours")}</b>
                                    </label>
                                    <input
                                        type="number"
                                        id={`workerClass-rolHours-${index}`}
                                        className="form-control"
                                        value={workerClass.rolHours}
                                        onChange={(e) =>
                                            handleWorkerClassChange(index, "rolHours", e.target.value)
                                        }
                                    />
                                </div>
                                <div className="mb-3 col">
                                    <label
                                        htmlFor={`workerClass-leaveHours-${index}`}
                                        className="form-label"
                                    >
                                        {t("absenceReport:entity.leaveReport.type.abolished")} <b>{t("unit.hours")}</b>
                                    </label>
                                    <input
                                        type="number"
                                        id={`workerClass-leaveHours-${index}`}
                                        className="form-control"
                                        value={workerClass.leaveHours}
                                        onChange={(e) =>
                                            handleWorkerClassChange(index, "leaveHours", e.target.value)
                                        }
                                    />
                                </div>
                            </div>

                        </div>
                    )
                })}

                <button type="button end" className="btn btn-secondary float-right " onClick={addWorkerClass}>
                    <i className="fa-solid fa-plus"></i> {t("action.add")}
                </button>


            </div>


            <div className="text-end">
                <button type="submit" className="btn btn-primary text-end">
                    <i className="fa-solid fa-floppy-disk"></i>  {t("action.save")}
                </button>
            </div>
        </form>
    );
};

export default ContractModelForm;